import { useState } from 'react';
import { AxiosPublic } from '../utils/axios';
import { BoardsQueryParameter } from '@mvrb-frontend/shared-ui';
import AdminOrganizationModel from '../models/AdminOrganizaitonModel';

const BASE_URL = 'boards';

export const useGetBoards = () => {
  const [isFetching, setFetching] = useState(false);
  const [boardItems, setBoardItems] = useState<
    { value: string; label: string; abbreviation: string; lwb: boolean; color: string; position: number }[]
  >([]);
  const [boardAdmin, setBoardAdmin] = useState<AdminOrganizationModel>();
  return {
    isFetching,
    boardItems,
    boardAdmin,
    onLoad: async (queryParams?: BoardsQueryParameter) => {
      try {
        setFetching(true);
        const { data } = await AxiosPublic.get(`/${BASE_URL}`, {
          params: queryParams,
        });
        if (queryParams?.includePosition) {
          data.sort((a, b) => {
            return a.position - b.position;
          });
        }
        if (queryParams?.editBoard) {
          setBoardAdmin(new AdminOrganizationModel(data[0]));
        } else {
          setBoardItems(
            data.map(item => ({
              value: item.id,
              label: item.name,
              abbreviation: item.abbreviation,
              lwb: item.lwb,
              color: item.hexColor,
              position: item.position,
            })),
          );
        }
        setFetching(false);
      } catch (e) {
        setFetching(false);
      }
    },
  };
};
